export const ArrowLightLine = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3296 10.894L8.51309 12.71L8.50009 2H7.50009L7.51309 12.7035L5.70309 10.8935L4.99609 11.6L6.95559 13.5595C7.09489 13.6988 7.26026 13.8093 7.44226 13.8847C7.62426 13.9601 7.81934 13.9989 8.01634 13.9989C8.21335 13.9989 8.40842 13.9601 8.59043 13.8847C8.77243 13.8093 8.9378 13.6988 9.07709 13.5595L11.0366 11.6L10.3296 10.894Z"
      fill="currentColor"
    />
  </svg>
);
